// extracted by mini-css-extract-plugin
export default {"button":"StatusWarning_button__+zaXi"};